import { Box, Stack } from '@mui/material'
import React from 'react'

const NotFound = () => {
  return (
    <Stack marginTop="10rem" justifyContent="center" alignItems="center" xs={{width:"95%"}} >
      <img src="./error-2129569_1280.jpg" width="750px" alt="" />
    </Stack>
  )
}

export default NotFound
